import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-318dc783"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "source-outer"
}
const _hoisted_2 = { class: "source-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Sources:", -1))
const _hoisted_4 = { class: "source-container" }
const _hoisted_5 = { class: "source-list-wrapper" }
const _hoisted_6 = {
  class: "source-list",
  ref: "sourceList"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Array.isArray(_ctx.sources) && _ctx.sources.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_ctx.showLeftArrow)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "arrow left",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
                }, "‹"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "source",
                    key: index
                  }, [
                    _createTextVNode(_toDisplayString(index + 1) + " ", 1),
                    _createElementVNode("button", {
                      class: "button-source",
                      onClick: ($event: any) => (_ctx.openSource(source.url))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(source.title), 1)
                    ], 8, _hoisted_7)
                  ]))
                }), 128))
              ], 512)
            ]),
            (_ctx.showRightArrow)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "arrow right",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
                }, "›"))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}